<script setup>
import { onBeforeMount, toRefs } from "vue";
import { useStore } from "vuex";

    const props = defineProps({
        categories: {
            type: Object,
            required: true
        }
    });

    const store = useStore();

    onBeforeMount(() => {

        const { categories } = toRefs(props);

        store.state.allCategories = [];

        categories.value.forEach(element => {
        
            store.state.allCategories.push(element);

            if(element.subs.length > 0){
                element.subs.forEach(sub => {

                    sub.parent_name = element.name;

                    store.state.allCategories.push(sub)

                });
            }

        });

    });
    
</script>

<template>
    <option
        v-for="(category, index) in store.state.allCategories" :key="index"
        :value="category.id"
    >
        {{ category.sub == 'Yes' ? '&rarr;' : ''}} {{ category.name }}
    </option>
</template>